import { render, staticRenderFns } from "./validation-warning-modal.vue?vue&type=template&id=27322610&scoped=true&"
import script from "./validation-warning-modal.ts?vue&type=script&lang=ts&"
export * from "./validation-warning-modal.ts?vue&type=script&lang=ts&"
import style0 from "./validation-warning-modal.scss?vue&type=style&index=0&id=27322610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27322610",
  null
  
)

export default component.exports